(() => {
  'use strict';
  if (customElements.get('abmh-continuation')) return;

  customElements.define('abmh-continuation', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.deduplicate !== 'true') return;
      this.abort?.abort();
      this.abort = new AbortController();
      this.syncSelection();
      document.addEventListener('abmh:selection-change', () => this.syncSelection(), {signal:this.abort.signal});
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    syncSelection() {
      const editorial = document.querySelector('#abm-product-grid');
      const ids = editorial
        ? [...editorial.querySelectorAll('[data-product]')].map(card => card.dataset.product)
        : (this.dataset.editorialIds || '').split('|').filter(Boolean);
      const excluded = new Set(ids);
      for (const card of this.querySelectorAll('[data-abmh-product]')) {
        card.hidden = excluded.has(card.dataset.abmhProduct);
      }
    }
  });
})();
